/**
 * Bank Account Type utilities (Plaid-style type/subtype)
 *
 * IMPORTANT: Keep behavior stable. These helpers are intentionally simple
 * and mirror existing inline logic used across onboarding + settings.
 */

/**
 * @deprecated Prefer deriveAccountTypeKeyFromApi({ accountType, accountSubtype }).
 * This is a legacy fallback for old/untyped records only.
 */
export const deriveAccountTypeKey = (accountName) => {
  const raw = (accountName || "").toString().trim().toLowerCase();
  if (!raw) return "";
  if (raw.includes("checking")) return "checking";
  if (raw.includes("savings")) return "savings";
  if (raw.includes("credit")) return "credit_card";
  return "";
};

export const deriveAccountTypeKeyFromApi = ({ accountType, accountSubtype } = {}) => {
  const st = (accountSubtype || "")
    .toString()
    .trim()
    .toLowerCase()
    .replaceAll("_", " ");

  if (st === "checking") return "checking";
  if (st === "savings") return "savings";
  if (st === "credit card") return "credit_card";

  const t = (accountType || "").toString().trim().toLowerCase();
  if (t === "credit") return "credit_card";
  if (t === "depository") return "checking";
  return "";
};

export const plaidTypeSubtypeFromTypeKey = (typeKey) => {
  const k = (typeKey || "").toString().trim().toLowerCase();
  if (k === "credit_card") return { type: "credit", subtype: "credit card" };
  if (k === "savings") return { type: "depository", subtype: "savings" };
  if (k === "checking") return { type: "depository", subtype: "checking" };
  return { type: null, subtype: null };
};

export const plaidTypeSubtypeFromSubtypeValue = (subtypeValue) => {
  const normalizedSubtype = (subtypeValue || "checking")
    .toString()
    .trim()
    .toLowerCase()
    .replaceAll("_", " ");

  const subtype =
    normalizedSubtype === "credit card" ? "credit card" :
    normalizedSubtype === "savings" ? "savings" :
    "checking";

  return {
    type: subtype === "credit card" ? "credit" : "depository",
    subtype,
  };
};

export const deriveAccountTypeLabel = (accountTypeKey) => {
  if (accountTypeKey === "checking") return "Checking";
  if (accountTypeKey === "savings") return "Savings";
  if (accountTypeKey === "credit_card") return "Credit Card";
  return "Bank Account";
};

export const csvAmountSignConventionFromTypeKey = (typeKey) =>
  (typeKey || "") === "credit_card" ? "plaid" : "lucro";
